module.exports = __webpack_public_path__ + "static/logo-52cfc14ee1b8e33bf436ac743262abaa.png";